import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import {Provider} from 'react-redux';
import {store} from './reduxFeature/';
import App from './App';

ReactDOM.render(
	<Provider store={store}>
		<App/> 
	</Provider>,
  	document.getElementById('root')
);